import { z } from 'zod';

import type {
  ResolveRcScopeRequest,
  ResolveRcScopeResponse,
} from './resolve-rc-scope.dto.js';
import { RegulatoryIdentitySchema } from '../counterparties/counterparties.schema.js';
import { RcScopeTypeSchema } from './shipments-types.js';

export const ResolveRcScopeRequestSchema: z.ZodType<ResolveRcScopeRequest> = z
  .object({
    companyId: z.uuid(),
    stationId: z.uuid(),
    storeId: z.uuid().optional(),
    locationId: z.uuid().optional(),
  })
  .strict();

export const ResolveRcScopeResponseSchema: z.ZodType<ResolveRcScopeResponse> = z
  .object({
    rcScopeType: RcScopeTypeSchema,
    rcScopeId: z.uuid(),
    regulatoryIdentity: RegulatoryIdentitySchema,
    scopeLabel: z.string().trim().min(1),
    timeZone: z.string().trim().min(1).nullable().optional(),
    storeId: z.uuid(),
    locationId: z.uuid(),
    stationId: z.uuid(),
  })
  .strict();
